import { useEffect } from "react";
import * as localService from "../services/localService";
import logger from "../utils/logger";

/**
 * SessionMonitor component that handles automatic logout when user session expires
 * This component should be placed at the root level of the app
 */
const SessionMonitor = () => {
  useEffect(() => {
    // Check if we're on a public page - don't run session monitoring on public pages
    const publicPages = [
      "/home",
      "/signin",
      "/auth/signin",
      "/signup",
      "/host-experience",
      "/report-issue",
      "/corporate-page",
      "/terms-of-use",
      "/privacy-policy",
    ];
    const currentPath = window.location.pathname;

    if (publicPages.includes(currentPath)) {
      logger.log("On public page, skipping session monitoring");
      return;
    }

    // Check if user is authenticated
    if (localService.isAuthenticated()) {
      logger.log("Setting up session monitoring for authenticated user");

      // Set up session monitoring to check every 30 seconds
      localService.setupSessionMonitoring(30000);

      // Also check immediately when component mounts
      const wasLoggedOut = localService.checkTokenExpiryAndLogout();
      if (wasLoggedOut) {
        logger.log("User was automatically logged out on session monitor initialization");
      }
    } else {
      logger.log("No authenticated user found, skipping session monitoring");
    }

    // Cleanup function to clear session monitoring when component unmounts
    return () => {
      localService.clearSessionMonitoring();
    };
  }, []);

  // This component doesn't render anything
  return null;
};

export default SessionMonitor;
